<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Approve Payment">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog1" v-model="modal" :return-value.sync="fromDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="From Date" v-model="fromDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="fromDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog1.save(fromDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog" v-model="modal1" :return-value.sync="toDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="To Date" v-model="toDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="toDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal1 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(toDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-autocomplete key="id" v-model="selectedStatus" menu-props="auto" label="Select Status" @change="onStart()" :items="PAYMENT_STATUS" item-text="text" item-value="value"> </v-autocomplete>
        </v-col>
      </v-row>

      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table sort-by hide-default-footer :single-expand="true" show-expand :items-per-page="-1" :headers="headers" :items="tableData" :search="search" item-key="paymentOrder.receiptNo">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Approve Payment</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn x-small outlined color="indigo" @click="approve(item)">
            {{ item.status === 'APPROVAL_WAITING' ? 'Approve Payment' : 'View Payment' }}
          </v-btn> </template
        >approve
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pb-4 pt-4">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      Type
                    </th>
                    <th class="text-center">
                      Date of Payment
                    </th>
                    <th class="text-center" v-if="item.mode === 'INTERNET_PAYMENT'">
                      InterNet Payment
                    </th>

                    <th class="text-center" v-if="item.mode === 'CHEQUE'">
                      Cheque
                    </th>
                    <th class="text-center" v-if="item.mode === 'DEMAND_DRAFT'">
                      Demand Draft
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center" justify="center">{{ item.paymentOrder.notes.type || '' }}</td>
                    <td align="center" justify="center">{{ new Date(item.dateOfPayment).toLocaleString() }}</td>
                    <td align="center" justify="center" v-if="item.mode === 'INTERNET_PAYMENT'">
                      Bank Name : {{ item.bankName || 'N/A' }}<br />
                      PaymentType:{{ item.paymentType || 'N/A' }}
                    </td>
                    <td align="center" justify="center" v-if="item.mode === 'CHEQUE'">
                      Bank Name : {{ item.bankName || 'N/A' }}<br />
                      Payment Type:{{ item.paymentType || 'N/A' }}<br />
                      IFSC Code:{{ item.IFSCCode || 'N/A' }}<br />
                      MICR Code:{{ item.MICRCode || 'N/A' }}<br />
                      Branch Name:{{ item.branchName || 'N/A' }}
                    </td>
                    <td align="center" justify="center" v-if="item.mode === 'DEMAND_DRAFT'">
                      DD No: {{ item.ddNO || 'N/A' }}<br />
                      Drawn NO:{{ item.drawnNO || 'N/A' }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
      </v-data-table>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
// import CONSTANTS from '@/utils/constants'

import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
// import _ from 'lodash'
export default {
  components: { MaterialCard },
  name: 'franchiseeOrderNodal',
  data () {
    return {
      isLoading: false,
      PAYMENT_STATUS: [
        {
          text: 'COLLECTED',
          value: 'COLLECTED'
        },
        { text: 'APPROVED', value: 'APPROVED' },

        { text: 'REJECTED', value: 'REJECTED' },
        { text: 'APPROVAL_WAITING', value: 'APPROVAL_WAITING' }
      ],
      checkedRows: [],
      selectedStatus: 'APPROVAL_WAITING',
      singleSelect: false,
      companyName: '',
      modal: false,
      modal1: false,
      fromDate: moment(new Date())
        .subtract(1, 'month')
        .format('YYYY-MM-DD'),
      toDate: new Date().toISOString().substr(0, 10),
      expanded: [],
      singleExpand: true,
      inProgress: false,
      search: '',
      franchiseeID: '',
      headers: [
        { text: 'Receipt No', value: 'paymentOrder.receiptNo', sortable: true },
        { text: 'Name', sortable: true, value: 'paymentOrder.notes.name' },
        { text: 'Franchisee', value: 'paymentOrder.notes.franchiseeName', sortable: true },
        { text: 'Class', value: 'paymentOrder.notes.class', sortable: true },
        { text: 'Payment Mode', value: 'paymentOrder.paymentMode', sortable: true },
        { text: 'status', value: 'status', sortable: true },

        { text: 'Enquiry Code', value: 'paymentOrder.notes.enquiryCode', sortable: true },
        { text: 'Enrollment Code', value: 'paymentOrder.notes.enrollmentCode', sortable: true },
        { text: 'Payment Order', value: 'paymentOrder.amount', sortable: true },

        { text: 'Action', value: 'actions' }
      ],
      tableData: []
    }
  },

  async created () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    toDate: async function (val) {
      await this.onFranchiseeChange()
    },
    fromDate: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  methods: {
    approve: async function (item) {
      let that = this

      try {
        that.isLoading = true
        that.$router.push({ name: 'ApprovePaymentDetails', params: { enquiryID: item.id } })
        that.isLoading = false
        console.log('thanks for sending ')
      } catch (e) {
      } finally {
        that.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        Utils.helper.openDrawer(this, !this.franchiseeID)
        if (this.franchiseeID) {
          await this.onStart()
        }
        this.inProgress = false
      }
    },

    onStart: async function () {
      if (!this.franchiseeID) {
        return this.$dialog.error({
          text: 'Please select Franchisee',
          title: 'Error'
        })
      }

      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/payments/offline?franchiseeID=${this.franchiseeID}&fromDate=${this.fromDate}&toDate=${this.toDate}&status=${this.selectedStatus}`)

        this.tableData = data
        this.tableData.forEach(item => {
          item.paymentOrder.amount = Number(item.paymentOrder.amount) / 100
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
